// source: v1alpha1/script_processing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var v1alpha1_common_pb = require('../v1alpha1/common_pb.js');
goog.object.extend(proto, v1alpha1_common_pb);
goog.exportSymbol('proto.pb.v1alpha1.Character', null, global);
goog.exportSymbol('proto.pb.v1alpha1.DeleteScriptRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.DeleteScriptResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GetScriptInfoRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GetScriptInfoResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GetScriptPDFRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.GetScriptPDFResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ListScriptsRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ListScriptsResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ProcessCategory', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ProcessScriptRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ProcessScriptResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.Script', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ScriptFileChunk', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ScriptFileChunk.FileType', null, global);
goog.exportSymbol('proto.pb.v1alpha1.ScriptInfo', null, global);
goog.exportSymbol('proto.pb.v1alpha1.SignedUrlRequest', null, global);
goog.exportSymbol('proto.pb.v1alpha1.SignedUrlRequest.MethodType', null, global);
goog.exportSymbol('proto.pb.v1alpha1.SignedUrlResponse', null, global);
goog.exportSymbol('proto.pb.v1alpha1.SimilarScript', null, global);
goog.exportSymbol('proto.pb.v1alpha1.UploadScriptResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.SignedUrlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.SignedUrlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.SignedUrlRequest.displayName = 'proto.pb.v1alpha1.SignedUrlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.SignedUrlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.SignedUrlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.SignedUrlResponse.displayName = 'proto.pb.v1alpha1.SignedUrlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ScriptFileChunk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.ScriptFileChunk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ScriptFileChunk.displayName = 'proto.pb.v1alpha1.ScriptFileChunk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.UploadScriptResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.UploadScriptResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.UploadScriptResponse.displayName = 'proto.pb.v1alpha1.UploadScriptResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ProcessScriptRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.ProcessScriptRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ProcessScriptRequest.displayName = 'proto.pb.v1alpha1.ProcessScriptRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ProcessScriptResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.ProcessScriptResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ProcessScriptResponse.displayName = 'proto.pb.v1alpha1.ProcessScriptResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.SimilarScript = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.SimilarScript, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.SimilarScript.displayName = 'proto.pb.v1alpha1.SimilarScript';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GetScriptPDFRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.GetScriptPDFRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GetScriptPDFRequest.displayName = 'proto.pb.v1alpha1.GetScriptPDFRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GetScriptPDFResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.GetScriptPDFResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GetScriptPDFResponse.displayName = 'proto.pb.v1alpha1.GetScriptPDFResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.DeleteScriptRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.DeleteScriptRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.DeleteScriptRequest.displayName = 'proto.pb.v1alpha1.DeleteScriptRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.DeleteScriptResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.DeleteScriptResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.DeleteScriptResponse.displayName = 'proto.pb.v1alpha1.DeleteScriptResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GetScriptInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.GetScriptInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GetScriptInfoRequest.displayName = 'proto.pb.v1alpha1.GetScriptInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.GetScriptInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.GetScriptInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.GetScriptInfoResponse.displayName = 'proto.pb.v1alpha1.GetScriptInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ScriptInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.ScriptInfo.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.ScriptInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ScriptInfo.displayName = 'proto.pb.v1alpha1.ScriptInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.Character = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.v1alpha1.Character, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.Character.displayName = 'proto.pb.v1alpha1.Character';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ListScriptsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.ListScriptsRequest.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.ListScriptsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ListScriptsRequest.displayName = 'proto.pb.v1alpha1.ListScriptsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.ListScriptsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.ListScriptsResponse.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.ListScriptsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.ListScriptsResponse.displayName = 'proto.pb.v1alpha1.ListScriptsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.v1alpha1.Script = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.v1alpha1.Script.repeatedFields_, null);
};
goog.inherits(proto.pb.v1alpha1.Script, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.v1alpha1.Script.displayName = 'proto.pb.v1alpha1.Script';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.SignedUrlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.SignedUrlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.SignedUrlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    method: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contentType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    objectPathPrefix: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.SignedUrlRequest}
 */
proto.pb.v1alpha1.SignedUrlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.SignedUrlRequest;
  return proto.pb.v1alpha1.SignedUrlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.SignedUrlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.SignedUrlRequest}
 */
proto.pb.v1alpha1.SignedUrlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectName(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.v1alpha1.SignedUrlRequest.MethodType} */ (reader.readEnum());
      msg.setMethod(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectPathPrefix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.SignedUrlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.SignedUrlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.SignedUrlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pb.v1alpha1.SignedUrlRequest.MethodType = {
  METHOD_UNSPECIFIED: 0,
  METHOD_GET: 1,
  METHOD_PUT: 2
};

/**
 * optional string object_name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.getObjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.SignedUrlRequest} returns this
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.setObjectName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MethodType method = 2;
 * @return {!proto.pb.v1alpha1.SignedUrlRequest.MethodType}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.getMethod = function() {
  return /** @type {!proto.pb.v1alpha1.SignedUrlRequest.MethodType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.v1alpha1.SignedUrlRequest.MethodType} value
 * @return {!proto.pb.v1alpha1.SignedUrlRequest} returns this
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.SignedUrlRequest} returns this
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.setContentType = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pb.v1alpha1.SignedUrlRequest} returns this
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.clearContentType = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.hasContentType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string object_path_prefix = 4;
 * @return {string}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.getObjectPathPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.SignedUrlRequest} returns this
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.setObjectPathPrefix = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pb.v1alpha1.SignedUrlRequest} returns this
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.clearObjectPathPrefix = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.SignedUrlRequest.prototype.hasObjectPathPrefix = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.SignedUrlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.SignedUrlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.SignedUrlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.SignedUrlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    signedUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.SignedUrlResponse}
 */
proto.pb.v1alpha1.SignedUrlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.SignedUrlResponse;
  return proto.pb.v1alpha1.SignedUrlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.SignedUrlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.SignedUrlResponse}
 */
proto.pb.v1alpha1.SignedUrlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.SignedUrlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.SignedUrlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.SignedUrlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.SignedUrlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignedUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string signed_url = 1;
 * @return {string}
 */
proto.pb.v1alpha1.SignedUrlResponse.prototype.getSignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.SignedUrlResponse} returns this
 */
proto.pb.v1alpha1.SignedUrlResponse.prototype.setSignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ScriptFileChunk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ScriptFileChunk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ScriptFileChunk.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptTitle: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: msg.getData_asB64(),
    fileType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ScriptFileChunk}
 */
proto.pb.v1alpha1.ScriptFileChunk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ScriptFileChunk;
  return proto.pb.v1alpha1.ScriptFileChunk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ScriptFileChunk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ScriptFileChunk}
 */
proto.pb.v1alpha1.ScriptFileChunk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptTitle(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {!proto.pb.v1alpha1.ScriptFileChunk.FileType} */ (reader.readEnum());
      msg.setFileType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ScriptFileChunk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ScriptFileChunk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ScriptFileChunk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getFileType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pb.v1alpha1.ScriptFileChunk.FileType = {
  FILE_TYPE_UNSPECIFIED: 0,
  FILE_TYPE_PDF: 1
};

/**
 * optional string script_title = 1;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.getScriptTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptFileChunk} returns this
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.setScriptTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pb.v1alpha1.ScriptFileChunk} returns this
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional FileType file_type = 3;
 * @return {!proto.pb.v1alpha1.ScriptFileChunk.FileType}
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.getFileType = function() {
  return /** @type {!proto.pb.v1alpha1.ScriptFileChunk.FileType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pb.v1alpha1.ScriptFileChunk.FileType} value
 * @return {!proto.pb.v1alpha1.ScriptFileChunk} returns this
 */
proto.pb.v1alpha1.ScriptFileChunk.prototype.setFileType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.UploadScriptResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.UploadScriptResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.UploadScriptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.UploadScriptResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptPdfUri: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.UploadScriptResponse}
 */
proto.pb.v1alpha1.UploadScriptResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.UploadScriptResponse;
  return proto.pb.v1alpha1.UploadScriptResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.UploadScriptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.UploadScriptResponse}
 */
proto.pb.v1alpha1.UploadScriptResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptPdfUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.UploadScriptResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.UploadScriptResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.UploadScriptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.UploadScriptResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptPdfUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string script_pdf_uri = 1;
 * @return {string}
 */
proto.pb.v1alpha1.UploadScriptResponse.prototype.getScriptPdfUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.UploadScriptResponse} returns this
 */
proto.pb.v1alpha1.UploadScriptResponse.prototype.setScriptPdfUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ProcessScriptRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ProcessScriptRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ProcessScriptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ProcessScriptRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptPdfUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pipelineType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ProcessScriptRequest}
 */
proto.pb.v1alpha1.ProcessScriptRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ProcessScriptRequest;
  return proto.pb.v1alpha1.ProcessScriptRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ProcessScriptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ProcessScriptRequest}
 */
proto.pb.v1alpha1.ProcessScriptRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptPdfUri(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.v1alpha1.PIPELINE_TYPE} */ (reader.readEnum());
      msg.setPipelineType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ProcessScriptRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ProcessScriptRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ProcessScriptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ProcessScriptRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptPdfUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPipelineType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string script_pdf_uri = 1;
 * @return {string}
 */
proto.pb.v1alpha1.ProcessScriptRequest.prototype.getScriptPdfUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ProcessScriptRequest} returns this
 */
proto.pb.v1alpha1.ProcessScriptRequest.prototype.setScriptPdfUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PIPELINE_TYPE pipeline_type = 2;
 * @return {!proto.pb.v1alpha1.PIPELINE_TYPE}
 */
proto.pb.v1alpha1.ProcessScriptRequest.prototype.getPipelineType = function() {
  return /** @type {!proto.pb.v1alpha1.PIPELINE_TYPE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.v1alpha1.PIPELINE_TYPE} value
 * @return {!proto.pb.v1alpha1.ProcessScriptRequest} returns this
 */
proto.pb.v1alpha1.ProcessScriptRequest.prototype.setPipelineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ProcessScriptResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ProcessScriptResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ProcessScriptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ProcessScriptResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.pb.v1alpha1.ScriptInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ProcessScriptResponse}
 */
proto.pb.v1alpha1.ProcessScriptResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ProcessScriptResponse;
  return proto.pb.v1alpha1.ProcessScriptResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ProcessScriptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ProcessScriptResponse}
 */
proto.pb.v1alpha1.ProcessScriptResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.ScriptInfo;
      reader.readMessage(value,proto.pb.v1alpha1.ScriptInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ProcessScriptResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ProcessScriptResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ProcessScriptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ProcessScriptResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.v1alpha1.ScriptInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScriptInfo info = 1;
 * @return {?proto.pb.v1alpha1.ScriptInfo}
 */
proto.pb.v1alpha1.ProcessScriptResponse.prototype.getInfo = function() {
  return /** @type{?proto.pb.v1alpha1.ScriptInfo} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.ScriptInfo, 1));
};


/**
 * @param {?proto.pb.v1alpha1.ScriptInfo|undefined} value
 * @return {!proto.pb.v1alpha1.ProcessScriptResponse} returns this
*/
proto.pb.v1alpha1.ProcessScriptResponse.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.ProcessScriptResponse} returns this
 */
proto.pb.v1alpha1.ProcessScriptResponse.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.ProcessScriptResponse.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.SimilarScript.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.SimilarScript.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.SimilarScript} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.SimilarScript.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scriptPdfUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    similarity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.SimilarScript}
 */
proto.pb.v1alpha1.SimilarScript.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.SimilarScript;
  return proto.pb.v1alpha1.SimilarScript.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.SimilarScript} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.SimilarScript}
 */
proto.pb.v1alpha1.SimilarScript.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptPdfUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSimilarity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.SimilarScript.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.SimilarScript.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.SimilarScript} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.SimilarScript.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScriptPdfUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSimilarity();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional string script_name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.SimilarScript.prototype.getScriptName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.SimilarScript} returns this
 */
proto.pb.v1alpha1.SimilarScript.prototype.setScriptName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string script_pdf_url = 2;
 * @return {string}
 */
proto.pb.v1alpha1.SimilarScript.prototype.getScriptPdfUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.SimilarScript} returns this
 */
proto.pb.v1alpha1.SimilarScript.prototype.setScriptPdfUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional float similarity = 3;
 * @return {number}
 */
proto.pb.v1alpha1.SimilarScript.prototype.getSimilarity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.SimilarScript} returns this
 */
proto.pb.v1alpha1.SimilarScript.prototype.setSimilarity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GetScriptPDFRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GetScriptPDFRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GetScriptPDFRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptPDFRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scriptPdfUri: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GetScriptPDFRequest}
 */
proto.pb.v1alpha1.GetScriptPDFRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GetScriptPDFRequest;
  return proto.pb.v1alpha1.GetScriptPDFRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GetScriptPDFRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GetScriptPDFRequest}
 */
proto.pb.v1alpha1.GetScriptPDFRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptPdfUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GetScriptPDFRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GetScriptPDFRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GetScriptPDFRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptPDFRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScriptPdfUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string script_name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.GetScriptPDFRequest.prototype.getScriptName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.GetScriptPDFRequest} returns this
 */
proto.pb.v1alpha1.GetScriptPDFRequest.prototype.setScriptName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string script_pdf_uri = 2;
 * @return {string}
 */
proto.pb.v1alpha1.GetScriptPDFRequest.prototype.getScriptPdfUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.GetScriptPDFRequest} returns this
 */
proto.pb.v1alpha1.GetScriptPDFRequest.prototype.setScriptPdfUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GetScriptPDFResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GetScriptPDFResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptPDFResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pdfBytes: msg.getPdfBytes_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GetScriptPDFResponse}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GetScriptPDFResponse;
  return proto.pb.v1alpha1.GetScriptPDFResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GetScriptPDFResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GetScriptPDFResponse}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPdfBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GetScriptPDFResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GetScriptPDFResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptPDFResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPdfBytes_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes pdf_bytes = 1;
 * @return {!(string|Uint8Array)}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.prototype.getPdfBytes = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes pdf_bytes = 1;
 * This is a type-conversion wrapper around `getPdfBytes()`
 * @return {string}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.prototype.getPdfBytes_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPdfBytes()));
};


/**
 * optional bytes pdf_bytes = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPdfBytes()`
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GetScriptPDFResponse.prototype.getPdfBytes_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPdfBytes()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pb.v1alpha1.GetScriptPDFResponse} returns this
 */
proto.pb.v1alpha1.GetScriptPDFResponse.prototype.setPdfBytes = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.DeleteScriptRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.DeleteScriptRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.DeleteScriptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeleteScriptRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.DeleteScriptRequest}
 */
proto.pb.v1alpha1.DeleteScriptRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.DeleteScriptRequest;
  return proto.pb.v1alpha1.DeleteScriptRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.DeleteScriptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.DeleteScriptRequest}
 */
proto.pb.v1alpha1.DeleteScriptRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.DeleteScriptRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.DeleteScriptRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.DeleteScriptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeleteScriptRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string script_name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.DeleteScriptRequest.prototype.getScriptName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.DeleteScriptRequest} returns this
 */
proto.pb.v1alpha1.DeleteScriptRequest.prototype.setScriptName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.DeleteScriptResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.DeleteScriptResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.DeleteScriptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeleteScriptResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    deleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.DeleteScriptResponse}
 */
proto.pb.v1alpha1.DeleteScriptResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.DeleteScriptResponse;
  return proto.pb.v1alpha1.DeleteScriptResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.DeleteScriptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.DeleteScriptResponse}
 */
proto.pb.v1alpha1.DeleteScriptResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.DeleteScriptResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.DeleteScriptResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.DeleteScriptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.DeleteScriptResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool deleted = 1;
 * @return {boolean}
 */
proto.pb.v1alpha1.DeleteScriptResponse.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.v1alpha1.DeleteScriptResponse} returns this
 */
proto.pb.v1alpha1.DeleteScriptResponse.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GetScriptInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GetScriptInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GetScriptInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GetScriptInfoRequest}
 */
proto.pb.v1alpha1.GetScriptInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GetScriptInfoRequest;
  return proto.pb.v1alpha1.GetScriptInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GetScriptInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GetScriptInfoRequest}
 */
proto.pb.v1alpha1.GetScriptInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GetScriptInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GetScriptInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GetScriptInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string script_name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.GetScriptInfoRequest.prototype.getScriptName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.GetScriptInfoRequest} returns this
 */
proto.pb.v1alpha1.GetScriptInfoRequest.prototype.setScriptName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.GetScriptInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.GetScriptInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.GetScriptInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.pb.v1alpha1.ScriptInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.GetScriptInfoResponse}
 */
proto.pb.v1alpha1.GetScriptInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.GetScriptInfoResponse;
  return proto.pb.v1alpha1.GetScriptInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.GetScriptInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.GetScriptInfoResponse}
 */
proto.pb.v1alpha1.GetScriptInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.ScriptInfo;
      reader.readMessage(value,proto.pb.v1alpha1.ScriptInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.GetScriptInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.GetScriptInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.GetScriptInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.GetScriptInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.v1alpha1.ScriptInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScriptInfo info = 1;
 * @return {?proto.pb.v1alpha1.ScriptInfo}
 */
proto.pb.v1alpha1.GetScriptInfoResponse.prototype.getInfo = function() {
  return /** @type{?proto.pb.v1alpha1.ScriptInfo} */ (
    jspb.Message.getWrapperField(this, proto.pb.v1alpha1.ScriptInfo, 1));
};


/**
 * @param {?proto.pb.v1alpha1.ScriptInfo|undefined} value
 * @return {!proto.pb.v1alpha1.GetScriptInfoResponse} returns this
*/
proto.pb.v1alpha1.GetScriptInfoResponse.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.GetScriptInfoResponse} returns this
 */
proto.pb.v1alpha1.GetScriptInfoResponse.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.GetScriptInfoResponse.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.ScriptInfo.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ScriptInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ScriptInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ScriptInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptPdfUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scriptTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
    author: jspb.Message.getFieldWithDefault(msg, 3, ""),
    studio: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    genre: jspb.Message.getFieldWithDefault(msg, 6, ""),
    genreConfidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    charactersList: jspb.Message.toObjectList(msg.getCharactersList(),
    proto.pb.v1alpha1.Character.toObject, includeInstance),
    keyMomentsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    numPages: jspb.Message.getFieldWithDefault(msg, 10, 0),
    numScenes: jspb.Message.getFieldWithDefault(msg, 11, 0),
    uploadedBy: jspb.Message.getFieldWithDefault(msg, 12, ""),
    comments: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ScriptInfo}
 */
proto.pb.v1alpha1.ScriptInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ScriptInfo;
  return proto.pb.v1alpha1.ScriptInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ScriptInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ScriptInfo}
 */
proto.pb.v1alpha1.ScriptInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptPdfUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScriptTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudio(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGenre(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGenreConfidence(value);
      break;
    case 8:
      var value = new proto.pb.v1alpha1.Character;
      reader.readMessage(value,proto.pb.v1alpha1.Character.deserializeBinaryFromReader);
      msg.addCharacters(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addKeyMoments(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumPages(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumScenes(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadedBy(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ScriptInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ScriptInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ScriptInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptPdfUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScriptTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGenre();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGenreConfidence();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getCharactersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.pb.v1alpha1.Character.serializeBinaryToWriter
    );
  }
  f = message.getKeyMomentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getNumPages();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getNumScenes();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getComments();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string script_pdf_url = 1;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getScriptPdfUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setScriptPdfUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string script_title = 2;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getScriptTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setScriptTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string author = 3;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getAuthor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setAuthor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string studio = 4;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getStudio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setStudio = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.clearStudio = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.hasStudio = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string genre = 6;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getGenre = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setGenre = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional float genre_confidence = 7;
 * @return {number}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getGenreConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setGenreConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * repeated Character characters = 8;
 * @return {!Array<!proto.pb.v1alpha1.Character>}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getCharactersList = function() {
  return /** @type{!Array<!proto.pb.v1alpha1.Character>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.v1alpha1.Character, 8));
};


/**
 * @param {!Array<!proto.pb.v1alpha1.Character>} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
*/
proto.pb.v1alpha1.ScriptInfo.prototype.setCharactersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.pb.v1alpha1.Character=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.Character}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.addCharacters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.pb.v1alpha1.Character, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.clearCharactersList = function() {
  return this.setCharactersList([]);
};


/**
 * repeated string key_moments = 9;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getKeyMomentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setKeyMomentsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.addKeyMoments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.clearKeyMomentsList = function() {
  return this.setKeyMomentsList([]);
};


/**
 * optional int32 num_pages = 10;
 * @return {number}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getNumPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setNumPages = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 num_scenes = 11;
 * @return {number}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getNumScenes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setNumScenes = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string uploaded_by = 12;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getUploadedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setUploadedBy = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.clearUploadedBy = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.hasUploadedBy = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string comments = 13;
 * @return {string}
 */
proto.pb.v1alpha1.ScriptInfo.prototype.getComments = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ScriptInfo} returns this
 */
proto.pb.v1alpha1.ScriptInfo.prototype.setComments = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.Character.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.Character.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.Character} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Character.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numberOfLines: jspb.Message.getFieldWithDefault(msg, 2, 0),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.Character}
 */
proto.pb.v1alpha1.Character.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.Character;
  return proto.pb.v1alpha1.Character.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.Character} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.Character}
 */
proto.pb.v1alpha1.Character.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfLines(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.Character.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.Character.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.Character} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Character.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumberOfLines();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.Character.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.Character} returns this
 */
proto.pb.v1alpha1.Character.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 number_of_lines = 2;
 * @return {number}
 */
proto.pb.v1alpha1.Character.prototype.getNumberOfLines = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.Character} returns this
 */
proto.pb.v1alpha1.Character.prototype.setNumberOfLines = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.pb.v1alpha1.Character.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.Character} returns this
 */
proto.pb.v1alpha1.Character.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.ListScriptsRequest.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ListScriptsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ListScriptsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListScriptsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    numberOfScripts: jspb.Message.getFieldWithDefault(msg, 1, 0),
    beforeTime: (f = msg.getBeforeTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    studio: jspb.Message.getFieldWithDefault(msg, 3, ""),
    organization: jspb.Message.getFieldWithDefault(msg, 4, ""),
    genresList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    authorsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    year: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest}
 */
proto.pb.v1alpha1.ListScriptsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ListScriptsRequest;
  return proto.pb.v1alpha1.ListScriptsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ListScriptsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest}
 */
proto.pb.v1alpha1.ListScriptsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfScripts(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBeforeTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudio(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganization(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addGenres(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addAuthors(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ListScriptsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ListScriptsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListScriptsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumberOfScripts();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBeforeTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStudio();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGenresList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getAuthorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int32 number_of_scripts = 1;
 * @return {number}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getNumberOfScripts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.setNumberOfScripts = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp before_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getBeforeTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
*/
proto.pb.v1alpha1.ListScriptsRequest.prototype.setBeforeTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.clearBeforeTime = function() {
  return this.setBeforeTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.hasBeforeTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string studio = 3;
 * @return {string}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getStudio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.setStudio = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string organization = 4;
 * @return {string}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getOrganization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.setOrganization = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.clearOrganization = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string genres = 5;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getGenresList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.setGenresList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.addGenres = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.clearGenresList = function() {
  return this.setGenresList([]);
};


/**
 * repeated string authors = 6;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getAuthorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.setAuthorsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.addAuthors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.clearAuthorsList = function() {
  return this.setAuthorsList([]);
};


/**
 * optional string year = 7;
 * @return {string}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.setYear = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pb.v1alpha1.ListScriptsRequest} returns this
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.clearYear = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.ListScriptsRequest.prototype.hasYear = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.ListScriptsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.ListScriptsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.ListScriptsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.ListScriptsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListScriptsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptsList: jspb.Message.toObjectList(msg.getScriptsList(),
    proto.pb.v1alpha1.Script.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.ListScriptsResponse}
 */
proto.pb.v1alpha1.ListScriptsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.ListScriptsResponse;
  return proto.pb.v1alpha1.ListScriptsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.ListScriptsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.ListScriptsResponse}
 */
proto.pb.v1alpha1.ListScriptsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.v1alpha1.Script;
      reader.readMessage(value,proto.pb.v1alpha1.Script.deserializeBinaryFromReader);
      msg.addScripts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.ListScriptsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.ListScriptsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.ListScriptsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.ListScriptsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pb.v1alpha1.Script.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Script scripts = 1;
 * @return {!Array<!proto.pb.v1alpha1.Script>}
 */
proto.pb.v1alpha1.ListScriptsResponse.prototype.getScriptsList = function() {
  return /** @type{!Array<!proto.pb.v1alpha1.Script>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.v1alpha1.Script, 1));
};


/**
 * @param {!Array<!proto.pb.v1alpha1.Script>} value
 * @return {!proto.pb.v1alpha1.ListScriptsResponse} returns this
*/
proto.pb.v1alpha1.ListScriptsResponse.prototype.setScriptsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pb.v1alpha1.Script=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.Script}
 */
proto.pb.v1alpha1.ListScriptsResponse.prototype.addScripts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pb.v1alpha1.Script, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.ListScriptsResponse} returns this
 */
proto.pb.v1alpha1.ListScriptsResponse.prototype.clearScriptsList = function() {
  return this.setScriptsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.v1alpha1.Script.repeatedFields_ = [2,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.v1alpha1.Script.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.v1alpha1.Script.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.v1alpha1.Script} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Script.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    authorsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    ingestedTime: (f = msg.getIngestedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    numPages: jspb.Message.getFieldWithDefault(msg, 4, 0),
    numCharacters: jspb.Message.getFieldWithDefault(msg, 5, 0),
    genresList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    genreConfidencesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.v1alpha1.Script}
 */
proto.pb.v1alpha1.Script.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.v1alpha1.Script;
  return proto.pb.v1alpha1.Script.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.v1alpha1.Script} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.v1alpha1.Script}
 */
proto.pb.v1alpha1.Script.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAuthors(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setIngestedTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumPages(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumCharacters(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addGenres(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addGenreConfidences(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.v1alpha1.Script.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.v1alpha1.Script.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.v1alpha1.Script} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.v1alpha1.Script.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getIngestedTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNumPages();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNumCharacters();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getGenresList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getGenreConfidencesList();
  if (f.length > 0) {
    writer.writePackedFloat(
      7,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pb.v1alpha1.Script.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string authors = 2;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.Script.prototype.getAuthorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.setAuthorsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.addAuthors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.clearAuthorsList = function() {
  return this.setAuthorsList([]);
};


/**
 * optional google.protobuf.Timestamp ingested_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pb.v1alpha1.Script.prototype.getIngestedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pb.v1alpha1.Script} returns this
*/
proto.pb.v1alpha1.Script.prototype.setIngestedTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.clearIngestedTime = function() {
  return this.setIngestedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.v1alpha1.Script.prototype.hasIngestedTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 num_pages = 4;
 * @return {number}
 */
proto.pb.v1alpha1.Script.prototype.getNumPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.setNumPages = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 num_characters = 5;
 * @return {number}
 */
proto.pb.v1alpha1.Script.prototype.getNumCharacters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.setNumCharacters = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated string genres = 6;
 * @return {!Array<string>}
 */
proto.pb.v1alpha1.Script.prototype.getGenresList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.setGenresList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.addGenres = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.clearGenresList = function() {
  return this.setGenresList([]);
};


/**
 * repeated float genre_confidences = 7;
 * @return {!Array<number>}
 */
proto.pb.v1alpha1.Script.prototype.getGenreConfidencesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.setGenreConfidencesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.addGenreConfidences = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.v1alpha1.Script} returns this
 */
proto.pb.v1alpha1.Script.prototype.clearGenreConfidencesList = function() {
  return this.setGenreConfidencesList([]);
};


/**
 * @enum {number}
 */
proto.pb.v1alpha1.ProcessCategory = {
  UNSPECIFIED: 0,
  GENRE: 1,
  COVERAGE: 2
};

goog.object.extend(exports, proto.pb.v1alpha1);
